import React, { useEffect, useState } from 'react';
import axios from 'axios';
const config = require('../../config/config.json');

interface RowData {
    // Define the structure of your table data
    base_currency: string;
    quote_currency: string;
    rate: number;
    edited_at: string;
    // Add more properties as needed
  }

  const DataTableExchange = () => {
    const [data, setData] = useState<RowData[]>([]);
  
    useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await axios.get(config.backend.url + '/api/exchangerates'); // Replace with your backend API URL
          setData(response.data);
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      };
  
      fetchData();
    }, []);

      return (
        <table>
          <thead>
            <tr>
              <th className='table-header'>BASE</th>
              <th className='table-header'>QUOTE</th>
              <th className='table-header'>RATE</th>
              <th className='table-header'>EDITED</th>
              {/* Add more headers as needed */}
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => (
              <tr key={index}>
                <td className='table-row'>{row.base_currency}</td>
                <td className='table-row'>{row.quote_currency}</td>
                <td className='table-row'>{row.rate}</td>
                <td className='table-row'>{row.edited_at}</td>
                {/* Add more cells as needed */}
              </tr>
            ))}
          </tbody>
        </table>
      );
    };
    
    export default DataTableExchange;